import React from "react";
import { Resizable } from "re-resizable";

interface SnResizableProps {
  height?: string | number;
  minWidth?: number;
  minHeight?: number;
  onResizeStop?: (height: number) => void;
  enable?: { [key: string]: boolean };
  children?: React.ReactNode;
  menuName: string;
  defaultSize: { [key: string]: string | number };
}

export default function SnResizableUND({
  height,
  minWidth,
  minHeight,
  onResizeStop,
  enable,
  children,
  menuName,
  defaultSize,
}: SnResizableProps) {
  const handleResizeStop = (
    event: MouseEvent | TouchEvent,
    direction: string,
    ref: HTMLElement,
    delta: { width: number; height: number }
  ) => {
    const height = ref.offsetHeight;

    let newMenuSize = {};
    let menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const parsedMenuSize = JSON.parse(menuSize);

      // menuName에 해당하는 객체가 없다면 추가
      if (!parsedMenuSize[menuName]) {
        parsedMenuSize[menuName] = {};
      }

      if (defaultSize.grid1Height) {
        parsedMenuSize[menuName].grid1Height = defaultSize.grid1Height;
        parsedMenuSize[menuName].grid2Height = height;
      } else {
        parsedMenuSize[menuName].grid1Height = height;
        parsedMenuSize[menuName].grid2Height = defaultSize.grid2Height;
      }
      newMenuSize = { ...parsedMenuSize };
    } else {
      if (defaultSize.grid1Height) {
        newMenuSize = {
          [menuName]: {
            grid1Height: defaultSize.grid1Height,
            grid2Height: height,
          },
        };
      } else {
        newMenuSize = {
          [menuName]: {
            grid1Height: height,
            grid2Height: defaultSize.grid2Height,
          },
        };
      }
    }
    localStorage.setItem("menuSize", JSON.stringify(newMenuSize));

    onResizeStop && onResizeStop(height);
  };

  return (
    <Resizable
      size={{
        ...(height && { height }),
      }}
      minWidth={minWidth}
      minHeight={minHeight}
      onResizeStop={handleResizeStop}
      enable={enable}
    >
      {children}
    </Resizable>
  );
}
